// Module
var code = "<div class=\"u-min-h-40\"> <!--ko with: _component--> <!--ko if: SetupValid--> <!--ko template: {html: GetSchedulerTemplate, afterRender: _view().AfterRender.bind(_view())}--><!--/ko--> <!--/ko--> <!--ko ifnot: SetupValid--> <!--ko template: {html: $data.GetInvalidSetupTemplate.bind($data)}--><!--/ko--> <!--/ko--> <!--/ko--> </div>";
// Exports
export default code;